import { getDate } from '@einhaus/meteoric-helpers';
import type { BarDuration } from '@einhaus/project314-types';
import { getLookbackDateForDuration } from '@/utils/dateHelpers/dateHelpers';

interface DateBounds {
    startDateTime?: string | null;
    endDateTime?: string | null;
}

export interface ChartDateWindow {
    startDateTime: string;
    endDateTime: string;
    hasDateTimeChanged: boolean;
}

export const hasExplicitChartDateWindow = ({ startDateTime, endDateTime }: DateBounds): boolean =>
    startDateTime != null || endDateTime != null;

export const resolveChartDateWindow = (duration: BarDuration, props: DateBounds, query: DateBounds): ChartDateWindow => {
    const startDateTime = query.startDateTime ?? props.startDateTime;
    const endDateTime = query.endDateTime ?? props.endDateTime;

    return {
        startDateTime: startDateTime ?? getLookbackDateForDuration(duration),
        endDateTime: endDateTime ?? getDate({ format: 'ymdhms' }),
        // Caller and URL bounds own the window just like a manual date selection.
        hasDateTimeChanged: hasExplicitChartDateWindow({ startDateTime, endDateTime })
    };
};

export const changeChartDuration = <T extends ChartDateWindow & { duration: BarDuration }>(
    settings: T,
    duration: BarDuration
): Omit<T, 'duration'> & { duration: BarDuration } => ({
    ...settings,
    duration,
    startDateTime: settings.hasDateTimeChanged ? settings.startDateTime : getLookbackDateForDuration(duration),
    endDateTime: settings.hasDateTimeChanged ? settings.endDateTime : getDate({ format: 'ymdhms' })
});
